import styled from "styled-components";

const StyledLink = styled.a(({ theme }) => ({
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '150%',
    textDecoration: 'underline',
    color: theme.color.brandPrimary.light,
    cursor: 'pointer',

    [theme.breakpoint.lg()]: {
        fontSize: 16
    }
}))

export default StyledLink